import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AdminCreateInternalTrainingBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const adminCreateInternalTraining = createAsyncThunk<string, AdminCreateInternalTrainingBody, { extra: Partial<Dependencies> }>(
  "internalTrainings/createInternalTraining",
  async (training: AdminCreateInternalTrainingBody, { extra: { adminRepository } }) => {
    return adminRepository!.createInternalTraining(training);
  },
);

export const adminResetCreateInternalTraining = createAction("internalTrainings/resetCreateInternalTraining");
